module.exports = __webpack_public_path__ + "static/media/cacao4.9f974fb0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/cacao/cacao4.jpeg
// module id = 49
// module chunks = 0